import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  FormControl,
  FormLabel,
  Spinner,
  Select,
  Input,
  Button,
  useToast,
  ChakraProvider,
  Textarea,
  Switch,
  CloseButton,
  Box,
} from "@chakra-ui/react";
import {
  createEmailMessage,
  createExpertADP,
  getEmailMessage,
  getSurveyCatalogueADP,
 
} from "../../../services/http/surveyHttpService";
import { useTranslation } from "react-i18next";
import { HTTP_STATUS_CODES } from "../../../GrinsCostant";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import { extendTheme } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker.css"; // Import the CSS for datepicker
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
const CreateExpertModal = ({ isOpen, onClose, onSaveExpert }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [surveys, setSurveys] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNum, setPageNum] = useState(0);
  const [createNewEmailMessage, setCreateNewEmailMessage] = useState(false);
  const [emailMessages, setEmailMessages] = useState([]);
  const [emailMessageTextReadOnly, setEmailMessageTextReadOnly] = useState("");
  const [emailMessageTextReadOnlyFirst, setEmailMessageTextReadOnlyFirst] = useState("");

  const [payloadCreateEmailMessage, setPayloadCreateEmailMessage] = useState({});



  const themeDatePicker = extendTheme({
    components: {
      Input: {
        baseStyle: {
          field: {
            fontSize: "lg",
            padding: "12px",
          },
        },
      },
    },
  });
  useEffect(() => {
   
    setIsLoading(false);
    // Fai la chiamata API una sola volta al montaggio del componente
    getSurveyCatalogueADP({
      username: sessionStorage.getItem("username"),
      is_consensus: true,
      status: "draft",
    }).then((res) => {
      if (
        res != null &&
        res.survey_catalogue != null &&
        res.survey_catalogue.length > 0
      )
        setSurveys(res.survey_catalogue);
    });

    getEmailMessage(t, { username: sessionStorage.getItem("username"), is_consensus: true}).then(
      (res) => {
        console.log("Get Email Message", res);

        if(res.columns.length === 0) {
          setCreateNewEmailMessage(true)
        }else {

        setEmailMessages(res.columns);
        setEmailMessageTextReadOnly(res.columns[0].message_text)
        setEmailMessageTextReadOnlyFirst(res.columns[0].message_text)
        setFormData({ ...formData, message_id:res.columns[0].message_id});
      }
      }
    );
  }, []);

  const toast = useToast();

  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  

  const handleSubmit = () => {
    // Prepara l'oggetto da inviare al backend

   
    if(createNewEmailMessage) {

      if(payloadCreateEmailMessage.title && payloadCreateEmailMessage.message_text) {
        payloadCreateEmailMessage.owner = sessionStorage.getItem("username")
        payloadCreateEmailMessage.is_consensus = true
        createEmailMessage(t,payloadCreateEmailMessage).then(res => {
          console.log(res)


          if(res && res.message_id)
          setFormData({ ...formData, message_id: res.message_id});


        })
      }else {
        toast({
          title: "Errore Campi Mancanti Nella Creazione Messaggio Email",
          description: "",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return
      }
    }

    if (formData.name && formData.surname && formData.email && selectedDate) {
      setIsLoading(true);
      formData.status = "active";
      formData.owner = sessionStorage.getItem("username");

      if (formData.id_survey_info == null) {
        formData.id_survey_info = surveys[0].id_survey_info;
      }


      selectedDate.setUTCDate(selectedDate.getUTCDate() + 1);

      // Aggiungi un'ora
      selectedDate.setUTCHours(selectedDate.getUTCHours() + 1);
      formData.end_date= selectedDate.toISOString()


      formData.group_title= `${uuidv4()}_${formData.id_survey_info}_tempGroup`
      formData.group_description= `${uuidv4()}_${formData.id_survey_info}_tempGroup`
      formData.owner= sessionStorage.getItem("username")
      


    

      createExpertADP(t, formData)
        .then((res) => {
          if (res.status == HTTP_STATUS_CODES.OK) {
            onSaveExpert();

            onClose();


            setEmailMessageTextReadOnly(emailMessageTextReadOnlyFirst)
            setSelectedDate(null)
            setCreateNewEmailMessage(false)


            setPageNum(0);


            setIsLoading(false);

        

            toast({
              title: "",
              description: String(res.message),
              position: "top",
              status: "info",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {},
            });

            setFormData({})
          }
        })
        .catch((e) => {
          console.log(e)
          setIsLoading(false);
          toast({
            title: "Errore Salvataggio Esperto",
            description: "",
            status: "warning",
            duration: 4000,
            isClosable: true,
          });
        });
    } else {
      toast({
        title: "Errore Campi Mancanti! Inserire Tutti i Campi",
        description: "",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={()=> {onClose(); setPageNum(0) ;
        setEmailMessageTextReadOnly(emailMessageTextReadOnlyFirst);
        setSelectedDate(null);
        setCreateNewEmailMessage(false);}}
      isCentered
      size={"xl"}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bgColor={"#0888BE"} color={"white"} display="flex" justifyContent="space-between" >
          <Box>
            {t("survey.expertModal.insertDataOfExpert")}
          </Box>
          <Box>
            <CloseButton onClick={()=>{onClose(); 
            setEmailMessageTextReadOnly(emailMessageTextReadOnlyFirst);
            setSelectedDate(null);
            setFormData({}); setSelectedDate(null); setPageNum(0); setCreateNewEmailMessage(false)}}/>
          </Box>
        </ModalHeader>
        <ModalBody>
          {pageNum === 0 && (
            <>
              {" "}
              <FormControl mt={4}>
                <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.name")}</FormLabel>
                <Input
                value={formData.name}
                  placeholder={t("survey.expertModal.name")}
                  onChange={(e) => handleChange(e, "name")}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.surname")}</FormLabel>
                <Input
                value={formData.surname}
                  placeholder={t("survey.expertModal.surname")}
                  onChange={(e) => handleChange(e, "surname")}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>Email</FormLabel>
                <Input
                value={formData.email}
                  placeholder="Email"
                  onChange={(e) => handleChange(e, "email")}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.surveyConsensus")}</FormLabel>
                <Select

value={formData.id_survey_info || ""} 

                  onChange={(e) => {
                    handleChange(e, "id_survey_info");
                  }}
                >
                  {surveys.map((option) => (
                    <option
                      key={option.id_survey_info}
                      value={option.id_survey_info}
                    >
                      {option.title}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <ChakraProvider theme={themeDatePicker}>
                <FormControl mt={4}>
                  <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.selectEndDate")}</FormLabel>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                   
                    dateFormat="dd/MM/yyyy" // Shows both Date and Time
                    
                    customInput={<Input />}
                    placeholderText={t("survey.expertModal.selectDate")}
                  />
                </FormControl>
              </ChakraProvider>
            </>
          )}

          {pageNum === 1 && (
            <>

            {emailMessages && emailMessages.length > 0 && (

                  <FormControl  mt={4} display="flex" alignItems="center">
                  <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.createNewEmailMessage")}</FormLabel>
                  <Switch

                    isChecked={createNewEmailMessage}
                    id="email-alerts"
                    onChange={(e) => {
                      setCreateNewEmailMessage(e.target.checked);
                    }}
                  />
                </FormControl>
              )}
            

              {!createNewEmailMessage && (
                <>
                  <FormControl mt={4}>
                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.emailMessages")}</FormLabel>
                    <Select
                    value={formData.message_id || ""} // evita warning se undefined
                   
                      onChange={(e) => {
                        handleChange(e, "message_id");
                        
                       
                        setEmailMessageTextReadOnly( emailMessages.find(email => email.message_id === e.target.value).message_text)
                        

                      }}
                    >
                      {emailMessages.map((option) => (
                        <option
                          key={option.message_id}
                          value={option.message_id}
                        >
                          {option.title}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mt={4}>
                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>
                    {t("survey.expertModal.emailMessage")}:
                    </FormLabel>
                    <Textarea
                      placeholder="Email Message"
                      minH="250px" // Altezza minima di 500px
                      maxH="260px"
                      overflowY="auto" // Abilita lo scrolling verticale
                      resize="vertical" // Permette il ridimensionamento verticale
                      isReadOnly
                      value={emailMessageTextReadOnly}
                    />
                  </FormControl>
                </>
              )}

              {createNewEmailMessage && (
                <>
                   <FormControl mt={4} isRequired>
                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("survey.expertModal.titleEmailMessage")}</FormLabel>
                    <Input value={payloadCreateEmailMessage.title} onChange={(e)=> {   setPayloadCreateEmailMessage({ ...payloadCreateEmailMessage, title: e.target.value });
                    }} variant='filled' placeholder={t("survey.expertModal.titleEmailMessage")} name='Title Email Message' type='text' bg='white'/>
                    </FormControl>

                  <FormControl mt={4}>
                    <FormLabel
                      fontSize="lg"
                      color="rgba(11,78,90,255)"
                      fontWeight="semibold"
                    >
                      {t("survey.expertModal.emailMessage")}:
                    </FormLabel>
                    <Textarea
                      value={payloadCreateEmailMessage.message_text}
                      placeholder="Email Message"
                      minH="250px" // Altezza minima di 500px
                      maxH="260px"
                      overflowY="auto" // Abilita lo scrolling verticale
                      resize="vertical" // Permette il ridimensionamento verticale
                      onChange={(e) =>  setPayloadCreateEmailMessage({ ...payloadCreateEmailMessage, message_text: e.target.value })}
                      
                    />
                  </FormControl>
                </>
              )}
            </>
          )}
        </ModalBody>

        <ModalFooter>
          {pageNum == 0 && (
            <Button
              rightIcon={<ChevronRightIcon />}
              colorScheme="blue"
              mr={3}
              onClick={() => {
                setPageNum(1);
              }}
            >
              {t("survey.expertModal.next")}
            </Button>
          )}

          {pageNum == 1 && (
            <Button
              mr={3}
              leftIcon={<ChevronLeftIcon />}
              colorScheme="blue"
              onClick={() => {
                setPageNum(0);
              }}
            >
              {t("survey.expertModal.back")}
            </Button>
          )}

          {pageNum == 1 && (
            <Button
              colorScheme="green"
              mr={3}
              onClick={handleSubmit}
              isLoading={isLoading}
              spinner={<Spinner size="sm" />}
            >
              {isLoading ? "" : t("survey.expertModal.createExpertButton")}
            </Button>
          )}

          <Button colorScheme="red" onClick={()=>{onClose();  
            setEmailMessageTextReadOnly(emailMessageTextReadOnlyFirst);
            setSelectedDate(null);
             setFormData({}); setSelectedDate(null); setPageNum(0); setCreateNewEmailMessage(false)}}>
            {t("survey.expertModal.cancel")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateExpertModal;
